import React,{useEffect,useState} from 'react'
import DoctorHours from './DoctorHours'
import clinicbookingService from '../../../../../services/clinicbooking.service'
import CustomHours from './CustomHours'
import AddEditDoctorInfo from './AddEditDoctorInfo'
import ApptTypeToDocForm from './ApptTypeToDocForm'

function DocInfo({doc,handleEdit}) {
    const [doctor,setDoctor] = useState()
    const [editInfo,setEditInfo] = useState(false)
    const [apptEdit,setApptEdit] = useState(false)

useEffect(()=>{
    //console.log(doc)
    getDoctorById()
},[doc,editInfo])

const getDoctorById = ()=>{
 clinicbookingService.getDoctorById(doc.clinicId,doc.id)
 .then(res=>{
    setDoctor(res.data)
 })
 .catch(err=>{
    console.log(err)
 })
}

const toogleEdit = ()=>{
    setEditInfo(!editInfo)
}
const updateDoc = (doc)=>{
    setDoctor(doc)
}
const toogleApptEdit = ()=>{
    setApptEdit(!apptEdit)
}
  return (
    <>
     {doctor && <>
        <div className="d-flex justify-content-between">
            <h4>{doctor.name}</h4>
            <button className="btn btn-sm btn-secondary" onClick={()=>handleEdit(0)}><i className="bi bi-arrow-left-square"></i> Back</button>
        </div>
        {editInfo? <AddEditDoctorInfo doctor={doctor} updateDoc={updateDoc} toogleEdit={toogleEdit}/> :
        <div className="row mt-3">
            <div className="col-sm-4">
                <img src={doctor.photo_url} className='img-fluid rounded' />
            </div>
            <div className="col-sm-8">
                    
                    <p>Bio: {doctor.bio}</p>
                    <p>Status: {doctor.isActive===1?"Active":"Inactive"}</p>
                    <p>User Id: {doctor.userId}</p>
                    {apptEdit ? <ApptTypeToDocForm doctor={doctor} toogleApptEdit={toogleApptEdit} getDoctorById={getDoctorById}/> :
                    <>             
                        {doctor.apptTypes && doctor.apptTypes.map((type,index)=>{
                        return(<span key={index} className="badge bg-primary me-2">{type.apptType}</span>)
                         })}
                    </>
                    }
            </div>
        </div>
        }
        <div className="d-flex justify-content-end">
                    <button className="btn btn-sm btn-info me-3" onClick={toogleApptEdit}><i className="bi bi-pencil-square"></i> Edit Appointment Types</button>
                    <button className="btn btn-info btn-sm" onClick={toogleEdit}><i className="bi bi-pencil-square"></i> Edit Doctor Info</button>
        </div>
       
        <div className="row mt-3">
            <div className="col-12">
            <DoctorHours id={doctor.id} clinicid={doctor.clinicId}/>
            </div>
        </div>
        <div className="row mt-3">
            <div className="col-12">
                    <CustomHours doctorid={doctor.id} clinicid={doctor.clinicId} userid={doctor.userId}/>
            </div>
        </div>
    </>
}
    </>
   

  )
}

export default DocInfo